import { render, staticRenderFns } from "./ExportStartedPrompt.vue?vue&type=template&id=79cc0650"
import script from "./ExportStartedPrompt.vue?vue&type=script&lang=ts"
export * from "./ExportStartedPrompt.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports